const postQueryArgs = {
	postType: {
		value: ["post"],
		multiple: false,
		id: "postType",
		label: "Post types",
		description: "Select Post Types to Query",
	},
	s: {
		value: "",
		multiple: false,
		id: "s",
		label: "Keyword",
		description: "Search keyword, ex: hello",
	},
	postStatus: {
		value: [],
		multiple: false,
		id: "postStatus",
		label: "Post status",
		description: "Query post by post status",
	},
	order: {
		value: "",
		multiple: false,
		id: "order",
		label: "Order",
		description: "Post query order",
	},
	orderby: {
		value: [],

		multiple: false,
		id: "orderby",
		label: "Orderby",
		description: "Post query orderby",
	},
	metaKey: {
		value: "",
		multiple: false,
		id: "metaKey",
		label: "Meta fields key",
		description: "Post query by meta fields key",
		isPro: true,
	},
	// Category Parameters
	cat: {
		value: "",
		multiple: false,
		id: "cat",
		label: "Category ID",
		description: "Post query by Category ID",
	},
	categoryName: {
		value: "",
		multiple: false,
		id: "categoryName",
		label: "Category Name",
		description: "Post query by Category Name",
	},
	categoryAnd: {
		value: [],

		multiple: false,
		id: "categoryAnd",
		label: "Category And",
		description: "Post query by Category IDs",
		isPro: true,
	},
	categoryIn: {
		value: [],

		multiple: false,
		id: "categoryIn",
		label: "Category In",
		description: "Post query by Category IDs",
		isPro: true,
	},
	categoryNotIn: {
		value: [],

		multiple: false,
		id: "categoryNotIn",
		label: "Category Not In",
		description: "Post query by excluded Category IDs",
		isPro: true,
	},
	// Tag Parameters
	tag: {
		value: "",
		multiple: false,
		id: "tag",
		label: "Tags",
		description: "Post query by Tag slug",
	},
	tagId: {
		value: "",
		multiple: false,
		id: "tagId",
		label: "Tag Id",
		description: "Post query by Tag ID",
	},
	tagAnd: {
		value: "",

		multiple: false,
		id: "tagAnd",
		label: "Tag And",
		description: "Post query by Tag Ids",
		isPro: true,
	},
	tagIn: {
		value: "",

		multiple: false,
		id: "tagIn",
		label: "Tag In",
		description: "Post query by Tag ids",
		isPro: true,
	},
	tagNotIn: {
		value: "",

		multiple: false,
		id: "tagNotIn",
		label: "Tag Not In",
		description: "Post query by excluded Tag ids",
		isPro: true,
	},
	tagSlugAnd: {
		value: "",

		multiple: false,
		id: "tagSlugAnd",
		label: "Tag Slug And",
		description: "Post query by Tags slug",
		isPro: true,
	},
	tagSlugIn: {
		value: "",

		multiple: false,
		id: "tagSlugIn",
		label: "Tag Slug In",
		description: "Post query by excluded Tags slug",
		isPro: true,
	},
	// taxQuery: {
	// 	value: [],
	// 	multiple: false,
	// 	id: "taxQuery",
	// 	label: "Tax Query",
	// 	description: "Taxonomies query arguments",
	// 	isPro: true,
	// },
	taxQueryRelation: {
		value: "OR",
		multiple: false,
		id: "taxQueryRelation",
		label: "Taxonomy Query Relation",
		description: "Taxonomies query relation",
		isPro: true,
	},
	// // Date Parameters
	// dateQuery: {
	// 	value: [],

	// 	multiple: false,
	// 	id: "dateQuery",
	// 	label: "Date Query",
	// 	description: "Post query by date",
	// 	isPro: true,
	// },
	year: {
		value: "",
		multiple: false,
		id: "year",
		label: "Year",
		description: "Post query by year",
	},
	monthnum: {
		value: "",
		multiple: false,
		id: "monthnum",
		label: "Month",
		description: "Post query by month",
	},
	w: {
		value: "",
		multiple: false,
		id: "w",
		label: "Week",
		description: "Post query by week",
	},
	day: {
		value: "",
		multiple: false,
		id: "day",
		label: "Day",
		description: "Post query by day",
	},
	hour: {
		value: "",
		multiple: false,
		id: "hour",
		label: "Hour",
		description: "Post query by hour",
	},
	minute: {
		value: "",
		multiple: false,
		id: "minute",
		label: "Miniute",
		description: "Post query by miniute",
	},
	second: {
		value: "",
		multiple: false,
		id: "second",
		label: "Second",
		description: "Post query by second",
	},
	m: {
		value: "",
		multiple: false,
		id: "m",
		label: "Month",
		description: "Post query by month",
	},
	// // Author Parameters
	author: {
		value: "",
		multiple: false,
		id: "author",
		label: "Author",
		description: "Post query by Author ID",
	},
	authorName: {
		value: "",
		multiple: false,
		id: "authorName",
		label: "Author Name",
		description: "Post query by Author Name",
	},
	authorIn: {
		value: "",

		multiple: false,
		id: "authorIn",
		label: "Author In",
		description: "Post query by Author IDs",
		isPro: true,
	},
	authorNotIn: {
		value: "",

		multiple: false,
		id: "authorNotIn",
		label: "Author Not In",
		description: "Post query by exluded Author IDs",
		isPro: true,
	},
	p: {
		value: "",
		multiple: false,
		id: "p",
		label: "Post id",
		description: "Post query by single post id",
	},
	name: {
		value: "",
		multiple: false,
		id: "name",
		label: "Name",
		description: "Post query by post slug",
	},
	pageId: {
		value: "",
		multiple: false,
		id: "pageId",
		label: "Page Id",
		description: "Post query by single page id",
	},
	pagename: {
		value: "",
		multiple: false,
		id: "pagename",
		label: "Page name",
		description: "Post query by page slug",
	},
	postParent: {
		value: "",
		multiple: false,
		id: "postParent",
		label: "Post Parent",
		description: "Add {ID} to Post query by post parent id",
		isPro: true,
	},
	postParentIn: {
		value: "",
		multiple: false,
		id: "postParentIn",
		label: "Post Parent In",
		description: "Post query by post parent ids",
		isPro: true,
	},
	postParentNotIn: {
		value: "",
		multiple: false,
		id: "postParentNotIn",
		label: "Post Parent Not In",
		description: "Post query by excluded post parent ids",
		isPro: true,
	},
	postIn: {
		value: "",

		multiple: false,
		id: "postIn",
		label: "Post In",
		description: "Post query by multiple post ids, comma separated.",
		isPro: true,
	},
	postNotIn: {
		value: "",

		multiple: false,
		id: "postNotIn",
		label: "Post Not In",
		description: "Post query by excluded post ids",
		isPro: true,
	},
	postNameIn: {
		value: [{ slug: "" }],
		multiple: false,
		id: "postNameIn",
		label: "Post Name In",
		description: "Post query by post slugs",
		isPro: true,
	},
	hasPassword: {
		value: "",
		multiple: false,
		id: "hasPassword",
		label: "Has Password",
		description: "Post query for posts with passwords",
		isPro: true,
	},
	postPassword: {
		value: "",
		multiple: false,
		id: "postPassword",
		label: "Post Password",
		description: "Post query for posts with particular passwords",
		isPro: true,
	},
	commentCount: {
		value: { compare: "=", value: 10 },
		multiple: false,
		id: "commentCount",
		label: "Comment Count",
		description: "Post query by comment count",
		isPro: true,
	},
	nopaging: {
		value: "",
		multiple: false,
		id: "nopaging",
		label: "No Paging",
		description: "Enable show all posts or use pagination",
	},
	postsPerPage: {
		value: "",
		multiple: false,
		id: "postsPerPage",
		label: "Posts Per Page",
		description: "Number of post to show per page",
	},
	paged: {
		value: "",
		multiple: false,
		id: "paged",
		label: "Paged",
		description: "Pagination start with",
	},
	offset: {
		value: "",
		multiple: false,
		id: "offset",
		label: "Offset",
		description: "Number of post to displace or pass over",
		isPro: true,
	},
	postsPerArchivePage: {
		value: "",
		multiple: false,
		id: "postsPerArchivePage",
		label: "Posts Per Archive Page",
		description: "",
	},
	ignoreStickyPosts: {
		value: "",
		multiple: false,
		id: "ignoreStickyPosts",
		label: "Ignore Sticky Posts",
		description: "Ignore post from post query",
		isPro: true,
	},
	metaKey: {
		value: "",
		multiple: false,
		id: "metaKey",
		label: "Meta Key",
		description: "Post query by custom field key",
		isPro: true,
	},
	metaValue: {
		value: "",
		multiple: false,
		id: "metaValue",
		label: "Meta Value",
		description: "Post query by custom field value",
		isPro: true,
	},
	metaValueNum: {
		value: "",
		multiple: false,
		id: "metaValueNum",
		label: "Meta Value Num",
		description: "Post query by custom field value for number types",
		isPro: true,
	},
	metaCompare: {
		value: "",
		multiple: false,
		id: "metaCompare",
		label: "Meta Compare",
		description: "Meta query compare",
		isPro: true,
	},
	// metaQuery: {
	// 	value: [],

	// 	multiple: false,
	// 	id: "metaQuery",
	// 	label: "Meta Query",
	// 	description: "Advance meta fields query",
	// 	isPro: true,
	// },
	perm: {
		value: "readable",
		multiple: false,
		id: "perm",
		label: "Perm",
		description: "User permission parameter",
	},
	postMimeType: {
		value: "",
		multiple: false,
		id: "postMimeType",
		label: "Post Mime Type",
		description: "Post query by allwed post mime types",
		isPro: true,
	},
	cacheResults: {
		value: false,
		multiple: false,
		id: "cacheResults",
		label: "Cache Results",
		description: "Enable Post information cache",
		isPro: true,
	},
	updatePostMetaCache: {
		value: false,
		multiple: false,
		id: "updatePostMetaCache",
		label: "Update Post Meta Cache",
		description: "Enable Post meta information cache",
		isPro: true,
	},
	updatePostTermCache: {
		value: false,
		multiple: false,
		id: "updatePostTermCache",
		label: "Update Post Term Cache",
		description: "Enable Post term information cache",
		isPro: true,
	},
};

export default postQueryArgs;